// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voucher-list .el-form-item {\n  margin-right: 10px !important;\n  margin-bottom: 4px !important;\n}\n.voucher-list .el-form-item .el-form-item__content .el-input__inner {\n    padding: 0px 5px !important;\n}\n.voucher-list .el-form-item .el-form-item__content .el-date-editor .el-input__prefix {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
